import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { RootState, AppDispatch } from '../store';
import { fetchEvents, clearError } from '../store/eventsSlice';
import { CardGrid, AddCard } from '../components/common';
import EventCard from '../components/events/EventCard';
import CreateEventModal from '../components/events/CreateEventModal';

const DashboardPage: React.FC = () => {
    const [showCreateModal, setShowCreateModal] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const { events, isLoading, error } = useSelector(
        (state: RootState) => state.events
    );

    // Fetch events on mount
    useEffect(() => {
        dispatch(fetchEvents());
    }, [dispatch]);

    // Clear error on unmount
    useEffect(() => {
        return () => {
            dispatch(clearError());
        };
    }, [dispatch]);

    const handleEventClick = (eventId: string) => {
        navigate(`/events/${eventId}/map`);
    };

    const handleAddEventClick = () => {
        setShowCreateModal(true);
    };

    const handleModalClose = () => {
        setShowCreateModal(false);
    };

    return (
        <>
            <CardGrid
                title="Events"
                subtitle="Select an event to continue or create a new one"
                error={error}
                onDismissError={() => dispatch(clearError())}
                loading={isLoading && events.length === 0}
                empty={events.length === 0 && !isLoading}
                emptyTitle="No events yet"
                emptyMessage="Create your first event to start tracking military operations"
            >
                {/* Add Event Card - Always first */}
                <Col>
                    <AddCard label="Add Event" onClick={handleAddEventClick} />
                </Col>

                {/* Event Cards */}
                {events.map((event) => (
                    <Col key={event.id}>
                        <EventCard
                            event={event}
                            onClick={() => handleEventClick(event.id)}
                        />
                    </Col>
                ))}
            </CardGrid>

            <CreateEventModal show={showCreateModal} onHide={handleModalClose} />
        </>
    );
};

export default DashboardPage;
